<template>
  <div ref="cell" class="grid-view__cell grid-field-many-to-many__cell">
    <div class="grid-field-many-to-many__list">
      <div
        v-for="item in value"
        :key="item.id"
        class="field-multiple-collaborators__item"
      >
        <template v-if="item.id && item.name">
          <div
            class="field-multiple-collaborators__name background-color--light-gray"
          >
            <span class="field-multiple-collaborators__name-text">
              <SearchHighlightedText
                :text="getCollaboratorName(item, $store)"
                :search-term="searchTerm"
              />
            </span>
          </div>
          <div class="field-multiple-collaborators__initials">
            {{ getCollaboratorNameInitials(item, $store) }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import collaboratorName from '@baserow/modules/database/mixins/collaboratorName'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldMultipleCollaborators',
  components: { SearchHighlightedText },
  mixins: [collaboratorName],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
